var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 8,
  viewBox: "0 0 14 8"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F26100",
  fillRule: "evenodd",
  d: "M5.22 6.823 4.016 8.03 0 4.015 4.015 0 5.22 1.206 3.265 3.162H14v1.706H3.265z"
})));
export default SvgArrowLeft;